import { defineMessages } from 'react-intl';

export default defineMessages({
  navigationButtonsBack: {
    id: 'back_move_buttons.back',
  },
  navigationButtonsMove: {
    id: 'back_move_buttons.move',
  },
  navigationButtonSave: {
    id: 'navigation_button.save',
  },
});
